import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import cx from 'classnames';
import { Swipeable } from 'react-touch';
import TransactionInformationComponent from './TransactionInformationComponent';
import { isBOrVMRetail } from '../../../utils/BrandUtils';

class TransactionGroup extends React.Component {
  constructor(props) {
    super(props);
    this.onSwipeLeft = this.onSwipeLeft.bind(this);
    this.onSwipeRight = this.onSwipeRight.bind(this);
    this.getTransactionList = this.getTransactionList.bind(this);
  }

  getTransactionList() {
    const pendingTransactions = this.props.data.filter(({ posted }) => !posted);
    const postedTransactions = this.props.data.filter(({ posted }) => posted);
    const orderedDataResults = pendingTransactions.concat(postedTransactions);

    const transactionList = orderedDataResults.map((transaction) => {
      const _rowCustomClass =
        this.props.rowClickIndex === transaction.id
          ? this.props.rowCustomClass
          : '';

      return (
        <TransactionInformationComponent
          {...this.props}
          data={transaction}
          hasSelect={false}
          showSelectionTag={this.props.showSelectionTag}
          onRowSelect={this.props.onRowSelect}
          rowCustomClass={_rowCustomClass}
          onTableTagClick={this.props.onTableTagClick}
          openTransactionInProgressPopUp={
            this.props.openTransactionInProgressPopUp
          }
        />
      );
    });

    return transactionList;
  }

  onSwipeLeft = () =>
    this.props.accountType !== 'credit_card' && this.props.onSwipeLeft();
  onSwipeRight = () =>
    this.props.accountType !== 'credit_card' && this.props.onSwipeRight();

  render() {
    return (
      <div
        className={cx('datatable__group', {
          datatable__group__sme: !isBOrVMRetail(),
        })}
      >
        <div className="type--jura datatable__header">
          <p className="datatable__date">
            {this.props.date === moment().format('DD MMM YY')
              ? 'Today'
              : this.props.date}
          </p>
          {!isBOrVMRetail() && <p className="datatable__debit">Debit</p>}
          {!isBOrVMRetail() && <p className="datatable__credit">Credit</p>}
          {this.props.accountType !== 'credit_card' ? (
            <p className="datatable__balance" />
          ) : null}
          <p className="datatable__more" />
        </div>
        <Swipeable
          onSwipeLeft={this.onSwipeLeft}
          onSwipeRight={this.onSwipeRight}
        >
          <ul className="datatable__data">{this.getTransactionList()}</ul>
        </Swipeable>
      </div>
    );
  }
}

TransactionGroup.propTypes = {
  date: PropTypes.object,
  data: PropTypes.array,
  className: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.string,
  showSelectionTag: PropTypes.bool,
  onRowSelect: PropTypes.func,
};

TransactionGroup.defaultProps = {
  className: 'btn',
  btnName: '',
};

export default TransactionGroup;
